<template>
	<div class="">
	    <v-client-table :columns="columns" :data="templates" ref="table" :options="options">
	    	<div class="intro" slot="beforeFilter" style="position: relative;">
	    		<h2>{{$t('properties.overview.mail-templates')}}</h2>
	    	</div>
	    	<div slot="afterFilter" class="add-button search-only">
                <form>
                    <div class="icon">
                        <SvgIcon icon="search" />
                    </div>
                    <input type="text"
                    	v-model="filterText"
                    	v-on:keyup="filterTable('table')"
                    	autofill="off"
                    	autocomplete="false"
                    	:placeholder="$t('search.filterplaceholder')" />
                </form>
            </div>
	    	<div slot="templateName" slot-scope="props">
	    		<router-link :to="props.row.editLink">{{ props.row.templateName }}</router-link>
	    	</div>
	    </v-client-table>
	</div>
</template>

<script>
	import Vue from 'vue';

	import {mapGetters} from 'vuex';
    import {ClientTable} from 'vue-tables-2';
    import SvgIcon from './Svg.vue';

    Vue.use(ClientTable);

	export default {
		data: () => ({
			filterText: '',
			templateList: [],
			columns: ['templateName'],
            options: {
                headings: {
                    templateName: 'Template'
                },
                sortable: ['templateName'],
                filterable: ['templateName'],
                texts:{
                    filterPlaceholder: 'Search',
                    filter: '',
                    noResults: 'None'
                },
                childRowTogglerFirst: false,
                columnsClasses:{
                   templateName: 'templateName'
                }
            }
		}),
		components:{
			SvgIcon
		},
		computed: {
			...mapGetters([
				'getToken'
			]),
			templates() {
				var list = [];
				for (var i in this.templateList) {
					let template = this.templateList[i];
					template.templateName = this.$t('mail-template.' + template.class + '-' + template.method);
					template.editLink = '/email-template/' + template.id;
					list.push(template);
				}
				return list;
			}
		},
		methods: {
			filterTable(ref) {
                this.$refs[ref].setFilter(this.filterText ? this.filterText : '');
            },
			load() {
				axios({
					method: 'GET',
					cancelToken: window.AuthorizationCancelSource.token,
                    url: window.config.apiUrl + 'api/mail-template'
				}).then(response => {
					this.templateList = response.data;
				});
			}
		},
		mounted(){
			this.options.headings.templateName = this.$t('email-manager.table.template');
			this.filterText = '';
			this.filterTable('table');
			this.options.texts.noResults = this.$t('table.no-results');
		},
		created() {
			this.load();
		}
	}
</script>
